import React from 'react'
// components
import SelectedPlanItems from 'containers/SubPlan/layers/BL/SelectedItems'
import SubPlanStepper from 'components/Modals/CreateSubPlanModal/SubPlanStepper'
import SubPlanStepperAPI from 'containers/SubPlan/layers/API'
import SubPlanStepperBL from 'containers/SubPlan/layers/BL/Stepper'

const SubPlanStepperContainer: React.FC<any> = (props) => (
  <SubPlanStepperAPI {...props}>
    <SelectedPlanItems>
      <SubPlanStepperBL>
        <SubPlanStepper />
      </SubPlanStepperBL>
    </SelectedPlanItems>
  </SubPlanStepperAPI>
)

export default SubPlanStepperContainer
